"use strict";

import angular from "angular";

import SceneFac from "./sceneFac";

export default angular
  .module("factories", [])
  .factory(SceneFac.UID, SceneFac.factory).name;



// WEBPACK FOOTER //
// ./src/app/factories/index.js